<template>
  <div
    class="price-and-button d-flex align-items-center justify-content-between gap-3"
  >
    <div class="price-details text-start heading fw-bold flex-grow-1">
      <Price :price="booking.sellingPrice" />
      <div class="caption mt-1">{{ t('reservations.FeeIncluded') }}</div>
    </div>
    <ViewDetailsButton
      :booking="props.booking"
      :buttonStyle="buttonStyle"
      @view-details="handleOpenPanel"
    />
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { useI18n } from 'vue-i18n'
  import store from '@/store'

  // Config
  import { ModalId } from '@/config/modalIds'

  // Components
  import ViewDetailsButton from '@/components/common/ViewDetailsButton.vue'
  import Price from '@/components/common/Price.vue'

  const props = defineProps({
    isReservation: {
      type: Boolean,
      required: true,
    },
    booking: {
      type: Object,
      required: true,
    },
  })

  const { t, n } = useI18n()

  const buttonStyle = computed(() =>
    props.isReservation
      ? 'button-secondary secondary-normal small flex-grow-1 action-button'
      : 'button-primary primary-normal small flex-grow-1'
  )

  const handleOpenPanel = () => {
    store.dispatch('booking/selectBooking', props.booking)
    store.commit('modal/open', ModalId.BOOKING_PANEL)
  }
</script>

<style scoped>
  .price-and-button {
    margin-top: 1rem;
  }
</style>
